<template>
  <div>
    <div v-if="state === 'select_time' && $vuetify.breakpoint.mdAndDown">
      <div class="mobileHeaderArea">
        <div class="mobileHeader mb-1 d-flex align-center">
          <div class="d-flex flex-grow-1" @click="returnBack">
            <div class="d-flex flex-column justify-center">
              <img src="../../assets/logo/roobroo-logo.png" width="110px" class="ml-2" alt="روب‌رو">
            </div>
            <div class="d-flex flex-column justify-center">
              بررسی و رزرو نوبت
            </div>
          </div>
          <v-btn
              v-if="showRestartButton"
              outlined
              small
              class="restartBtn px-2"
              @click="restartJourney"
          >
            شروع مجدد
          </v-btn>
          <div class="returnBtn d-flex align-center"
               :class="showBackButton && state === 'matchMaking' && 'ml-2'"
               @click="returnBack"
               v-if="showBackButton && state === 'matchMaking'">
            <img src="../../assets/image/user-journey/chevron-left.svg" width="24px" height="24px" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class=" mobileArea" v-else>
      <div class="headerArea">
        <v-row class="text-center">
          <v-col cols="4" lg="4"></v-col>
          <v-col cols="4" lg="4" class="d-flex flex-column justify-center  align-center text-center">
            <img src="../../assets/logo/roobroo-logo.png" width="150" alt="روب‌رو">
          </v-col>
          <v-col cols="4" lg="4" class="d-flex align-center justify-end headerActions">
            <v-btn
                v-if="showRestartButton"
                outlined
                small
                class="restartBtn"
                @click="restartJourney"
            >
              شروع مجدد
            </v-btn>
            <div class="returnBtn d-flex align-center"
                 :class="showBackButton && 'ml-2'"
                 @click="returnBack"
                 v-if="showBackButton">
              <img src="../../assets/image/user-journey/chevron-left.svg" width="24px" height="24px" alt="">
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    state: String
  },
  computed: {
    showRestartButton() {
      return (this.$route.path || '').includes('/user-journey')
    },
    showBackButton() {
      return !this.includesList.includes(this.state)
    },
  },
  data() {
    return {
      includesList: [
        'auth', 'suggest_doctors', 'matchMaking', 'freeSession'
      ]
    }
  },
  methods: {
    restartJourney() {
      localStorage.removeItem('set_session_token')
      window.location.reload()
    },
    returnBack() {
      this.$emit('goBack')
    }
  },
  mounted() {
    // Add/remove 'matchMaking' to header hide list via event bus
    this.$onEvent('addMatchMakingToHeaderIncludes', () => {
      if (!this.includesList.includes('matchMaking')) {
        this.includesList.push('matchMaking')
      }
    })
    this.$onEvent('removeMatchMakingFromHeaderIncludes', () => {
      const i = this.includesList.indexOf('matchMaking')
      if (i !== -1) {
        this.includesList.splice(i, 1)
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 200px) and (max-width: 800px) {
  .headerArea {
    padding: 0px 20px !important;
    height: 80px !important;
    z-index: 10;
    position: fixed;
    top: 0px;
    right: 0px;
    width: 100%;
  }
  .mobileArea {
    margin-bottom: 80px;
  }
  .mobileHeader {
    position: fixed;
    top: 0px;
    right: 0px;
    left: 0px;
    z-index: 10 !important;
  }
  .mobileHeaderArea {
    height: 50px;
  }
}

.mobileHeader {
  height: 52px;
  padding: 0px 20px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  font-size: 18px;
  font-weight: 700;
  z-index: 9999;
  background: white;
}

.mobileHeaderArea {
  background: #F6F9FC;
}

.headerArea {
  background: white;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  height: 88px;
  display: flex;
  flex-direction: column;
  padding: 0px 85px;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 10;
}

.headerActions {
  gap: 4px;
}

.returnBtn {
  color: #212121;
  /* Body/Medium/Medium16 */
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
}

.restartBtn {
  color: #212121 !important;
  border-color: #dbe4ed !important;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
}
</style>